export type AppReportId = 'weekly' | 'monthly' | 'class-diary' | 'offerings-period' | 'students-attendance' | 'honor-merit';

export interface AppReportDefinition {
  id: AppReportId;
  title: string;
  description: string;
  helper: string;
  iconKey: string;
  accentClassName: string;
  bgClassName: string;
}

export const reportDefinitions: AppReportDefinition[] = [
  {
    id: 'weekly',
    title: 'Relatório Semanal',
    description: 'Resumo por semana com bíblias, presentes, ausentes e visitantes por turma/segmento/congregação.',
    helper: 'Ideal para leitura no culto de domingo.',
    iconKey: 'calendar',
    accentClassName: 'text-emerald-700',
    bgClassName: 'bg-emerald-50',
  },
  {
    id: 'monthly',
    title: 'Relatório Mensal',
    description: 'Consolidação mensal da EBD no trimestre selecionado, com visão completa da igreja.',
    helper: 'Perfeito para fechamento mensal.',
    iconKey: 'file',
    accentClassName: 'text-sky-700',
    bgClassName: 'bg-sky-50',
  },
  {
    id: 'class-diary',
    title: 'Diário de Classe',
    description: 'Detalhamento por aula de todas as turmas para conferência geral e leitura completa.',
    helper: 'Complementa os dados já vistos na tela de lição.',
    iconKey: 'lesson',
    accentClassName: 'text-amber-700',
    bgClassName: 'bg-amber-50',
  },
  {
    id: 'offerings-period',
    title: 'Ofertas por período',
    description: 'Apura as ofertas no recorte selecionado com visão geral e detalhamento por congregação e turma.',
    helper: 'Mantido como relatório financeiro da EBD.',
    iconKey: 'coins',
    accentClassName: 'text-orange-700',
    bgClassName: 'bg-orange-50',
  },
  {
    id: 'students-attendance',
    title: 'Alunos Mais Presentes e Faltosos',
    description: 'Ranking de assiduidade e faltas por congregação, com foco de acompanhamento.',
    helper: 'Visão rápida para liderança e secretaria.',
    iconKey: 'users',
    accentClassName: 'text-indigo-700',
    bgClassName: 'bg-indigo-50',
  },
  {
    id: 'honor-merit',
    title: 'Honra ao Mérito EBD',
    description: 'Gera páginas de honra ao mérito em PDF por congregação para impressão e distribuição.',
    helper: 'Inclui página separadora por congregação.',
    iconKey: 'award',
    accentClassName: 'text-emerald-700',
    bgClassName: 'bg-emerald-50',
  },
];

const aliases: Record<string, AppReportId> = {
  'by-class': 'weekly',
  'by-lesson': 'class-diary',
  'honor-certificate': 'honor-merit',
};

export const getReportById = (reportId?: string | null): AppReportDefinition | undefined => {
  if (!reportId) {
    return undefined;
  }

  const normalized = (aliases[reportId] ?? reportId) as AppReportId;
  return reportDefinitions.find((item) => item.id === normalized);
};
